import { __rest } from "tslib";
import React, { useState, useRef } from 'react';
import message from '@web-common/components/UI/Message/SiriusMessage';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import classnames from 'classnames';
import { apis, apiHolder as api, inWindow } from 'api';
import styles from './editor.module.scss';
import errorCode from './error';
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const inEdm = api.api.getSystemApi().inEdm();
const recombineOrg = (data, index, whitespaceList) => {
    const sentsFeedback = data.essayFeedback.sentsFeedback;
    const res = [];
    let startPos = index;
    sentsFeedback.forEach((sent, index) => {
        if (index)
            startPos += whitespaceList[index - 1];
        if (sent.errorPosInfos.length !== 0) {
            sent.errorPosInfos.forEach(errorInfo => {
                res.push({
                    textStartPos: errorInfo.startPos,
                    startPos: startPos + errorInfo.startPos,
                    orgChunk: errorInfo.orgChunk,
                    correctChunk: errorInfo.correctChunk,
                    detailReason: errorInfo.detailReason,
                });
            });
        }
        startPos += sent.rawSent.length;
    });
    return { newList: res, newStartPos: startPos };
};
const reviseOrg = (contentHtml, recombineData) => {
    const tokenRegExp = new RegExp('<(?:' +
        '(?:!--([\\w\\W]*?)--!?>)|' +
        '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' +
        '(?:![Dd][Oo][Cc][Tt][Yy][Pp][Ee]([\\w\\W]*?)>)|' +
        '(?:!(--)?)|' +
        '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' +
        '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' +
        '(?:([A-Za-z][A-Za-z0-9\\-_:.]*)(\\s(?:[^\'">]+(?:"[^"]*"|\'[^\']*\'))*[^"\'>]*(?:"[^">]*|\'[^\'>]*)?|\\s*|\\/)>)' +
        ')', 'g');
    let matches;
    let index = 0;
    let textIndex = 0;
    let allText = '';
    let reviseList = recombineData.slice();
    let reviseItem = reviseList.shift();
    let res = '';
    let count = 0;
    if (!reviseItem)
        return contentHtml;
    while ((matches = tokenRegExp.exec(contentHtml))) {
        var matchText = matches[0];
        if (index < matches.index) {
            let text = contentHtml.substr(index, matches.index - index).replace(/\.(\S)/g, '. $1');
            text = text.replace(/\.$/g, '. ').replace(/"/g, "'");
            const revisedTextList = [];
            let revisedTextPrevindex = 0;
            if (reviseItem && textIndex > reviseItem.startPos) {
                reviseItem = reviseList.shift();
            }
            while (reviseItem && reviseItem.startPos >= textIndex && textIndex + text.length >= reviseItem.startPos + reviseItem.orgChunk.length) {
                const chunkInTextIndex = reviseItem.startPos - allText.length;
                const chunk = text.substr(chunkInTextIndex, reviseItem.orgChunk.length);
                if (chunk === reviseItem.orgChunk) {
                    count++;
                    revisedTextList.push(text.substring(revisedTextPrevindex, chunkInTextIndex), `<span class="lx-mce-grammar" data-correctChunk="${reviseItem.correctChunk}" data-detailReason="${reviseItem.detailReason}">${reviseItem.orgChunk}</span>`);
                    revisedTextPrevindex = chunkInTextIndex + reviseItem.orgChunk.length;
                }
                reviseItem = reviseList.shift();
            }
            revisedTextList.push(text.substring(revisedTextPrevindex));
            allText += text;
            textIndex += text.length;
            res += revisedTextList.join('');
        }
        res += matchText;
        index = matches.index + matchText.length;
    }
    console.log('countcountcountcountcount', count);
    return res;
};
const HOCEditorGrammar = (Component) => {
    const EditorGrammar = (props) => {
        const { ref } = props, rest = __rest(props, ["ref"]);
        const editorInstance = useRef();
        const [reviseCardVisible, setReviseCardVisible] = useState(false);
        const reviseCardPos = useRef({ top: 0, left: 0 });
        const mouseenterTargetRef = useRef();
        const showReviseCard = function (e) {
            const target = e.target;
            const rect = target.getBoundingClientRect();
            if (editorInstance.current) {
                const DOMUtils = editorInstance.current.dom;
                mouseenterTargetRef.current = target;
                const editorContainerPos = DOMUtils.getPos(editorInstance.current.getContentAreaContainer());
                reviseCardPos.current = { top: rect.bottom + editorContainerPos.y, left: rect.left + editorContainerPos.x };
                setReviseCardVisible(true);
            }
        };
        const hideReviseCard = () => {
            setReviseCardVisible(false);
        };
        const delPreReviseEles = (editor) => {
            const eles = editor.getDoc().querySelectorAll('.lx-mce-grammar');
            eles.forEach(el => {
                el.removeEventListener('mouseenter', showReviseCard);
                el.removeEventListener('mouseleave', hideReviseCard);
                el.replaceWith(el.innerText);
            });
        };
        const bindRevise = (editor) => {
            const grammarEls = editor.getDoc().querySelectorAll('.lx-mce-grammar');
            grammarEls.forEach(el => {
                el.addEventListener('mouseenter', showReviseCard);
                el.addEventListener('mouseleave', hideReviseCard);
            });
        };
        const removeAndExtractDom = (dom, selectors) => {
            const copyDom = dom.cloneNode(true);
            const removedInnerHTMLs = {};
            selectors.forEach(selector => {
                const el = copyDom.querySelector(selector);
                if (el) {
                    removedInnerHTMLs[selector] = el.innerHTML || '';
                    el.innerHTML = '';
                }
                else {
                    removedInnerHTMLs[selector] = '';
                }
            });
            return {
                removedInnerHTMLs,
                innerHTML: copyDom.innerHTML,
                innerText: copyDom.innerText,
            };
        };
        const getValidText = (bodyDom) => {
            const selectors = ['.pre-mail-content', '.mail-signature', '.mail-signature-ent'];
            const { removedInnerHTMLs, innerHTML, innerText } = removeAndExtractDom(bodyDom, selectors);
            return {
                transformText: innerText,
                transformHtml: innerHTML,
                preMailContentHtml: removedInnerHTMLs['.pre-mail-content'],
                mailSignatureHtml: removedInnerHTMLs['.mail-signature'],
                mailEnterpriseSignatureHtml: removedInnerHTMLs['.mail-signature-ent'],
            };
        };
        const grammarAction = (editor) => {
            editorInstance.current = editor;
            delPreReviseEles(editor);
            const { transformText, transformHtml, preMailContentHtml, mailSignatureHtml, mailEnterpriseSignatureHtml } = getValidText(editor.getBody());
            const contentText = transformText
                .replace(/\r?\n?/g, '')
                .replace(/\.(\S)/g, '. $1')
                .replace(/&nbsp;/g, ' ')
                .replaceAll(String.fromCharCode(160), ' ')
                .replace(/"/g, "'");
            const contentHtml = transformHtml
                .replace(/\r?\n?/g, '')
                .replace(/&nbsp;/g, ' ')
                .replaceAll(String.fromCharCode(160), ' ');
            let whitespace;
            const whitespaceList = [];
            const regexSpace = /[\.\?!。？！] {0,}/g;
            while ((whitespace = regexSpace.exec(contentText))) {
                whitespaceList.push(whitespace[0].length - 1);
            }
            let contentTextParams = [contentText];
            message.info('校对中…');
            if (contentText.length > 5000) {
                let reg;
                if (inWindow()) {
                    if (window && window.featureSupportInfo && window.featureSupportInfo.supportNativeProxy) {
                        reg = new RegExp('(?<=.)', 'g');
                    }
                }
                const contentTextList = reg ? contentText.split(reg) : [];
                contentTextParams = [];
                let curLength = 0;
                let cur = [];
                contentTextList.forEach(sent => {
                    curLength += sent.length;
                    if (curLength > 5000) {
                        contentTextParams.push(cur.join(''));
                        curLength = sent.length;
                        cur = [sent];
                    }
                    else {
                        cur.push(sent);
                    }
                });
                contentTextParams.push(cur.join(''));
            }
            Promise.all(contentTextParams.map(text => MailApi.getEnglishGrammar(text))).then((res) => {
                message.destroy();
                if (res.includes(null))
                    return message.error('校对失败！');
                const resNoNull = res;
                if (resNoNull.some(item => item.errorCode !== '0')) {
                    const item = resNoNull.find(item => item.errorCode !== '0');
                    const errorText = errorCode[item.errorCode] || '校对失败！';
                    message.error(errorText);
                    trackApi.track('pc_writeMailPage_grammar_correction_click', {
                        page: inEdm ? '营销写信' : '普通写信',
                        result: '失败',
                        number_of_characters: contentText.length,
                    });
                    return;
                }
                trackApi.track('pc_writeMailPage_grammar_correction_click', { page: inEdm ? '营销写信' : '普通写信', result: '成功', number_of_characters: contentText.length });
                let recombineData = [];
                resNoNull.reduce((startPos, item, index) => {
                    const offset = index ? 1 : 0;
                    const { newList, newStartPos } = recombineOrg(item.Result, startPos + offset, whitespaceList);
                    recombineData.push(...newList);
                    return newStartPos;
                }, 0);
                const revisedData = reviseOrg(contentHtml, recombineData).replace(/\.\s(\d)/g, '.$1');
                editor.setContent(revisedData, {
                    after: () => {
                        const preMail = editor.getDoc().querySelector('.pre-mail-content');
                        const mailSign = editor.getDoc().querySelector('.mail-signature');
                        const mailEntSign = editor.getDoc().querySelector('.mail-signature-ent');
                        preMail && (preMail.innerHTML = preMailContentHtml);
                        mailSign && (mailSign.innerHTML = mailSignatureHtml);
                        mailEntSign && (mailEntSign.innerHTML = mailEnterpriseSignatureHtml);
                        editor.nodeChanged();
                    },
                });
                bindRevise(editor);
                message.success('校对成功！');
            });
        };
        const getAttribute = (key) => {
            if (!mouseenterTargetRef.current)
                return '';
            return mouseenterTargetRef.current.getAttribute(key) || '';
        };
        const changeCorrectChunk = () => {
            if (!mouseenterTargetRef.current)
                return '';
            const correctChunk = getAttribute('data-correctChunk');
            mouseenterTargetRef.current.replaceWith(correctChunk);
            setReviseCardVisible(false);
            trackApi.track('pc_writeMailPage_correct__grammar_click');
        };
        const ignoreChunk = () => {
            if (!mouseenterTargetRef.current)
                return '';
            mouseenterTargetRef.current.replaceWith(mouseenterTargetRef.current.innerText);
            setReviseCardVisible(false);
            trackApi.track('pc_writeMailPage_neglection_click');
        };
        const ReviseCard = (React.createElement("div", { className: classnames(styles.reviseCard), onMouseEnter: () => {
                setReviseCardVisible(true);
            }, onMouseLeave: () => {
                setReviseCardVisible(false);
            } },
            React.createElement("div", { className: classnames(styles.content) },
                React.createElement("div", { className: classnames(styles.correctChunk), onClick: changeCorrectChunk }, getAttribute('data-correctChunk')),
                React.createElement("div", { className: classnames(styles.remind) }, "\u6B63\u786E\u7528\u6CD5\uFF0C\u70B9\u51FB\u53EF\u66FF\u6362"),
                React.createElement("div", { className: classnames(styles.detailReason) }, getAttribute('data-detailReason'))),
            React.createElement("div", { className: classnames(styles.footer), onClick: ignoreChunk },
                React.createElement("div", { className: classnames(styles.ignore) }, "\u5FFD\u7565"))));
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: props, grammarAction: grammarAction })),
            React.createElement(LxPopover, { visible: reviseCardVisible, setVisible: setReviseCardVisible, top: reviseCardPos.current.top, left: reviseCardPos.current.left }, ReviseCard)));
    };
    return React.forwardRef((props, ref) => React.createElement(EditorGrammar, Object.assign({}, props, { ref: ref })));
};
export default HOCEditorGrammar;
